import { useState, useEffect } from 'react';
import { api, endpoints } from '../config/api';
import { useAuth } from '../context/AuthContext';
import DataTable from '../components/DataTable';
import Modal from '../components/Modal';

function TopicsPage() {
  const { token } = useAuth();
  const [data, setData] = useState([]);
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modalOpen, setModalOpen] = useState(false);
  const [editing, setEditing] = useState(null);
  const [form, setForm] = useState({ eventId: '', title: '', description: '' });

  const load = async () => {
    try {
      const [t, e] = await Promise.all([api.get(endpoints.topics(), token), api.get(endpoints.events(), token)]);
      setData(t);
      setEvents(e);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  const handleSave = async (e) => {
    e.preventDefault();
    try {
      if (editing) await api.put(endpoints.topic(editing.id), form, token);
      else await api.post(endpoints.topics(), form, token);
      setModalOpen(false);
      setEditing(null);
      setForm({ eventId: '', title: '', description: '' });
      load();
    } catch (err) {
      alert(err?.message || 'Error');
    }
  };

  const handleDelete = async (row) => {
    if (!window.confirm('¿Eliminar?')) return;
    try {
      await api.delete(endpoints.topic(row.id), token);
      load();
    } catch (err) {
      alert(err?.message || 'Error');
    }
  };

  const columns = [
    { key: 'id', label: 'ID' },
    { key: 'title', label: 'Título' },
    { key: 'eventId', label: 'Evento' },
  ];

  return (
    <div>
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-2xl font-bold text-gray-800">Temas</h1>
        <button onClick={() => { setEditing(null); setForm({ eventId: events[0]?.id || '', title: '', description: '' }); setModalOpen(true); }} className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700">Nuevo</button>
      </div>
      {loading ? <p>Cargando...</p> : <DataTable columns={columns} data={data} onEdit={(r) => { setEditing(r); setForm(r); setModalOpen(true); }} onDelete={handleDelete} />}
      <Modal isOpen={modalOpen} onClose={() => setModalOpen(false)} title={editing ? 'Editar tema' : 'Nuevo tema'}>
        <form onSubmit={handleSave} className="space-y-4">
          <div><label className="block text-sm font-medium mb-1">Evento</label><select value={form.eventId} onChange={(e) => setForm((f) => ({ ...f, eventId: e.target.value }))} className="w-full px-3 py-2 border rounded" required>{events.map((ev) => <option key={ev.id} value={ev.id}>{ev.nombre}</option>)}</select></div>
          <div><label className="block text-sm font-medium mb-1">Título</label><input value={form.title} onChange={(e) => setForm((f) => ({ ...f, title: e.target.value }))} className="w-full px-3 py-2 border rounded" required /></div>
          <div><label className="block text-sm font-medium mb-1">Descripción</label><textarea value={form.descripcion} onChange={(e) => setForm((f) => ({ ...f, description: e.target.value }))} className="w-full px-3 py-2 border rounded" rows={3} /></div>
          <div className="flex gap-2 justify-end">
            <button type="button" onClick={() => setModalOpen(false)} className="px-4 py-2 border rounded">Cancelar</button>
            <button type="submit" className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700">Guardar</button>
          </div>
        </form>
      </Modal>
    </div>
  );
}

export default TopicsPage;
